import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["error", "inputUse", "options", "resolver", "specialOptions", "onChange", "onBlur"];
import { List } from 'immutable';
import { getFrom, setFrom } from 'customer-data-filters-ui/filterQueryFormat/LocalSettings';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
import { isOnlyActiveSalesforceOwner } from 'customer-data-objects/owners/isActiveOwner';
import { listOf, recordOf } from 'react-immutable-proptypes';
import FilterOperatorErrorType from 'customer-data-filters-ui/components/propTypes/FilterOperatorErrorType';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
import ReferenceInputEnum from 'customer-data-reference-ui-components/ReferenceInputEnum';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import ReferenceRecord from 'reference-resolvers/schema/ReferenceRecord';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import ReferenceResolverType from 'reference-resolvers/schema/ReferenceResolverType';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import isEmpty from 'transmute/isEmpty';
import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
const ownerOptionFormatter = record => {
  const isActive = record.referencedObject.get('remoteList').some(remote => remote.get('active') === true);
  const option = ReferenceRecord.toOption(record);
  if (isOnlyActiveSalesforceOwner(record.referencedObject)) {
    option.text = I18n.text('customerDataFiltersUI.customerDataFilters.FilterOperatorOwnerInput.salesforceUser', {
      name: option.text
    });
  }
  return Object.assign({}, option, {
    help: isActive ? record.description : I18n.text('customerDataFiltersUI.customerDataFilters.FilterOperatorOwnerInput.inactiveOwner', {
      email: record.description
    })
  });
};
const getOptions = (options, specialOptions, resolver) => {
  if (resolver) {
    return List.isList(specialOptions) ? specialOptions : List();
  }
  if (List.isList(options) && List.isList(specialOptions)) {
    return specialOptions.concat(options);
  }
  if (isEmpty(options) && List.isList(specialOptions)) {
    return specialOptions;
  }
  return options || List();
};
class FilterOperatorOwnerInput extends PureComponent {
  constructor(props) {
    super(props);
    this.handleDeactivatedUsersChange = ({
      target: {
        checked
      }
    }) => {
      setFrom(window.localStorage, 'showInactiveOwners', `${checked}`);
      this.setState({
        isOpen: true,
        showInactiveOwners: checked
      });
    };
    this.onOpenChange = evt => {
      this.setState({
        isOpen: evt.target.value
      });
      if (evt.target.value === false && this.props.onBlur) {
        this.props.onBlur();
      }
    };
    this.onChange = evt => {
      this.props.onChange(evt, this.state.isOpen);
    };
    this.state = {
      isOpen: false,
      showInactiveOwners: getFrom(window.localStorage, 'showInactiveOwners') === 'true'
    };
  }
  render() {
    const _this$props = this.props,
      {
        error,
        inputUse,
        options,
        resolver,
        specialOptions
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const {
      isOpen,
      showInactiveOwners
    } = this.state;
    const isError = error.get('error');
    const errorMessage = error.get('message');
    return /*#__PURE__*/_jsx(FormControl, {
      error: isError,
      validationMessage: isError ? errorMessage : null,
      children: /*#__PURE__*/_createElement(ReferenceInputEnum, Object.assign({}, rest, {
        buttonUse: inputUse === 'on-dark' ? 'form-on-dark' : undefined,
        dropdownFooter: /*#__PURE__*/_jsx(Checkbox, {
          checked: showInactiveOwners,
          onChange: this.handleDeactivatedUsersChange,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "customerDataFiltersUI.customerDataFilters.FilterOperatorOwnerInput.showInactiveOwners"
          })
        })
        // The owners API does not have fuzzy search so we need to pass exactly
        // what the user types to the BE in order for it to find owners with
        // diacritic letters in them
        // See: https://issues.hubspotcentral.com/browse/CRM-36087
        ,
        ignoreAccents: false,
        key: showInactiveOwners ? 'all' : 'active',
        menuWidth: "auto",
        onChange: this.onChange,
        onOpenChange: this.onOpenChange,
        open: isOpen,
        optionFormatter: ownerOptionFormatter,
        options: getOptions(options, specialOptions, resolver),
        requestOptions: {
          includeInactive: showInactiveOwners
        },
        resolver: resolver
      }))
    });
  }
}
FilterOperatorOwnerInput.propTypes = {
  error: FilterOperatorErrorType.isRequired,
  inputUse: PropTypes.oneOf(['on-dark']),
  onBlur: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  options: listOf(recordOf({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  })),
  resolver: ReferenceResolverType,
  specialOptions: listOf(recordOf({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  }))
};
export default FilterOperatorOwnerInput;